/**
 * Create a fcomposition id from a type and an id.
 *
 * The first 1 bit is the type of composition, the next 7 bits are the id of the composition,
 * resulting in a 8 unsigned bit integer for the representation with 128 possible values per type.
 *
 * Payload is a 24 bit unsigned integer that can be used to store additional information.
 *
 * (payload 24bit) | (subtype 7bit) | (type 1bit)
 *
 */
export const decodeFCompositionId = (id: number) => ({
  type: id & 0x01,
  subtype: (id >> 1) & 0x7f,
  payload: (id >> 8) & 0xffffff,
});
